export const FilledInfoIcon = ({
  strokeColor = "var(--color-stroke-primary)",
  strokeColor2 = "var(--color-txt-paragraph)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="Icons All">
      <circle id="Ellipse 138" cx="8" cy="8" r="8" fill={strokeColor} />
      <path
        id="Vector"
        d="M8 4.4375L8 9.4375"
        stroke={strokeColor2}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99935 13.1667C8.45958 13.1667 8.83268 12.7936 8.83268 12.3333C8.83268 11.8731 8.45958 11.5 7.99935 11.5C7.53912 11.5 7.16602 11.8731 7.16602 12.3333C7.16602 12.7936 7.53912 13.1667 7.99935 13.1667Z"
        fill={strokeColor2}
      />
    </g>
  </svg>
);
